export const formatPhone = (input: string): string => {
  if (!input) {
    return input;
  }

  return `+${input.slice(0, 3)} ${input.slice(3, 6)} ${input.slice(6)}`;
};
